import type { Component } from "vue"
import { deepdiveContent as markdownModules } from "@/lib/external-data/deepdiveContent"

const partialsDir = '/partials/deepdives'

type DeepdiveType = 'component' | 'markdown'

interface DeepdiveBase<T extends DeepdiveType> {
  type: Extract<DeepdiveType, T>
  path: string
}

export interface DeepdiveComponent extends DeepdiveBase<'component'> {
  component(): Promise<Component>
}

export interface DeepdiveMarkdown extends DeepdiveBase<'markdown'> {
  partialPath: string
}

export type Deepdive = DeepdiveComponent | DeepdiveMarkdown

export const prefix = "::deepdive/"

// add custom deep dives here, using type: component.
// add markdown deepdives to src/content/deepdives, will be picked up from there autoatically.
const deepdives: Record<string, Deepdive> = {
  "supported-exchanges": {
    type: 'component',
    component: async () => import("../content/SupportedExchanges/SupportedExchanges.vue"),
    path: 'supported-exchanges'
  }
}

markdownModules.forEach((slug) => {

  const namespacedSlug = 'details' + slug

  deepdives[namespacedSlug] = {
    type: 'markdown',
    path: namespacedSlug, 
    partialPath: partialsDir + slug
  }

})

export const getDeepdiveUrl = (requestedDeepdiveName: string) => {

  const deepdive = deepdives[requestedDeepdiveName]
  if(!deepdive) throw new Error(`No deepdive named "${requestedDeepdiveName}" was found!`)

  return '#' + prefix + deepdive.path
}

export {
  deepdives // make sure Object.entries processing is complete.
}